import FileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined"
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"
import Backdrop from "@mui/material/Backdrop"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import CardMedia from "@mui/material/CardMedia"
import CircularProgress from "@mui/material/CircularProgress"
import Dialog from "@mui/material/Dialog"
import IconButton from "@mui/material/IconButton"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2"
import { styled } from "@mui/material/styles"
import axios from "axios"
import * as fileDownload from "js-file-download"
import "pdfjs-dist/build/pdf.worker.entry"
import { useState } from "react"
import { FileIcon, defaultStyles } from "react-file-icon"
import { Document, Page, pdfjs } from "react-pdf"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import "react-pdf/dist/esm/Page/TextLayer.css"

import Column from "../../../common/components/Column"
import { PaddedContentColumn } from "../../../common/components/Column"
import { BaseGlassMixin } from "../../../common/components/GlassMixin"
import PageTopSection from "../../../common/components/PageTopSection"
import Row from "../../../common/components/Row"
import { useIsMobile } from "../../../common/utils"
import BorderedGrayChip from "../components/BorderedGrayChip"

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString()

export default function MyStrategyCenter() {
  const [openedVideoURL, setOpenedVideoURL] = useState(null)
  const [openedPDFURL, setOpenedPDFURL] = useState(null)
  const isMobile = useIsMobile()
  const STRATEGY_CENTER_PDF_BASE_URL = `https://${process.env.REACT_APP_AWS_S3_BUCKET}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_STRATEGY_CENTER_PDF_PATH}`

  const AI_VIDEOS = [
    {
      url: "https://player.vimeo.com/video/813615605?h=3aed904dc8",
      title: "Your Business Sticking Point and Why it is Everything",
      length: 266,
    },
    {
      url: "https://player.vimeo.com/video/824784960?h=c036890216",
      title: "CRMs - The Key To Success At Scale",
      length: 201,
    },
    {
      url: "https://player.vimeo.com/video/805992571?h=174a09c667",
      title: "The Power of Follow Up System for Recruiting",
      length: 204,
    },
    {
      url: "https://player.vimeo.com/video/805995093?h=729e68d404",
      title: "Reaching out to New Recruiting Leads",
      length: 236,
    },
  ]

  const PDFS = [
    new PDF(
      "Send the Hello Text",
      `${STRATEGY_CENTER_PDF_BASE_URL}Hello+Text+_+Be+Social+Send+V.2.pdf`,
      "send-the-hello-text.pdf",
      3.5
    ),
    new PDF(
      "Stick to the Script",
      `${STRATEGY_CENTER_PDF_BASE_URL}Intro+Call+Script.pdf`,
      "stick-to-the-script.pdf",
      2
    ),
    new PDF(
      "Email Templates and Follow Up",
      `${STRATEGY_CENTER_PDF_BASE_URL}email-campaigns-follow-up.pdf`,
      "email-campaigns-follow-up.pdf",
      1.6
    ),
    new PDF(
      "CRM Setup Guide",
      `${STRATEGY_CENTER_PDF_BASE_URL}Recruiting+CRM+Setup+Guide+2025.pdf`,
      "crm-setup-guide.pdf",
      3.7
    ),
  ]

  const VIDEOS = [
    { id: 902261286, title: "Webinar 2 - Contacts to Contracts" },
    { id: 902260363, title: "SmartSetter - Essentials for Success" },
  ]

  const JUDY_VIDEOS = [
    {
      url: "https://player.vimeo.com/video/666132442?badge=0&autopause=0&player_id=0&app_id=58479",
      title: "Judy LaDeur's Recruiting Do's and Don't's",
      length: 2905,
    },
    {
      url: "https://player.vimeo.com/video/666133666?badge=0&autopause=0&player_id=0&app_id=58479",
      title: "Judy LaDeur on DISC and Understanding Personalities",
      length: 2869,
    },
    {
      url: "https://player.vimeo.com/video/666131385?badge=0&autopause=0&player_id=0&app_id=58479",
      title: "Judy LaDeur's Interview Tips and Value Proposition",
      length: 2580,
    },
    {
      url: "https://player.vimeo.com/video/666129802?badge=0&autopause=0&player_id=0&app_id=58479",
      title: "Judy LaDeur on Marketing and Building Relationships",
      length: 3334,
    },
  ]

  function handleWatchButtonClickedWrapper(video) {
    return () => setOpenedVideoURL(video.url)
  }

  function handlePreviewPDFButtonClickedWrapper(pdf) {
    return () => setOpenedPDFURL(pdf.url)
  }

  function handleDownloadPDFButtonClickedWrapper(pdf) {
    return () => {
      axios
        .get(pdf.url, { responseType: "blob" })
        .then(({ data }) => fileDownload(data, pdf.downloadName))
    }
  }

  return (
    <Column>
      <PageTopSection title="My Strategy Center" />
      <PaddedContentColumn sx={{ pt: 0, pb: 2 }}>
        <Grid container columnSpacing={4}>
          <Grid xs={12} sm={9}>
            <Column gap={{ xs: 4, sm: 6 }} pt={3} pr={{ xs: 0, sm: 2 }}>
              <TitledSection title="Training Center">
                <VideoGrid
                  videos={AI_VIDEOS}
                  onWatchButtonClickedWrapper={handleWatchButtonClickedWrapper}
                />
              </TitledSection>
              <TitledSection title="Success Essentials">
                <Grid container spacing={4} width="calc(100% - 32px)">
                  {VIDEOS.map((video) => (
                    <Grid xs={12} sm={6} key={video.id}>
                      <div
                        style={{
                          padding: `${isMobile ? "69%" : "56.25%"} 0 0 0`,
                          position: "relative",
                        }}
                      >
                        <iframe
                          src={`https://player.vimeo.com/video/${video.id}?badge=0&autopause=0&player_id=0&app_id=58479`}
                          frameborder="0"
                          allow="autoplay; fullscreen; picture-in-picture"
                          style={{
                            position: "absolute",
                            top: isMobile ? "-90px" : 0,
                            left: 0,
                            width: isMobile ? "calc(100vw - 32px)" : "100%",
                            height: isMobile ? "360px" : "100%",
                          }}
                          title={video.title}
                        ></iframe>
                      </div>
                    </Grid>
                  ))}
                </Grid>
                <script src="https://player.vimeo.com/api/player.js"></script>
              </TitledSection>
              <TitledSection title="Training Center">
                <VideoGrid
                  videos={JUDY_VIDEOS}
                  onWatchButtonClickedWrapper={handleWatchButtonClickedWrapper}
                />
              </TitledSection>
            </Column>
          </Grid>
          <Grid
            xs={12}
            sm={3}
            sx={(theme) => ({
              borderLeft: {
                xs: "none",
                sm: `1px solid ${theme.palette.colors.gray200}`,
              },
              p: { xs: 2, sm: 4 },
              pt: { xs: theme.spacing(4), sm: theme.spacing(3) },
            })}
          >
            <TitledSection title="Free PDF Downloads">
              <Column gap={2} width="100%">
                {PDFS.map((pdf) => (
                  <PDFContainer key={pdf.title}>
                    <Row alignItems="center" gap={1}>
                      <Row sx={{ width: "32px" }}>
                        <FileIcon extension="pdf" {...defaultStyles.pdf} />
                      </Row>
                      <Column>
                        <Typography variant="h6" sx={{ lineHeight: 1.3 }}>
                          {pdf.title}
                        </Typography>
                        <Typography
                          variant="body1"
                          color="text.secondary"
                          fontSize="14px"
                        >
                          {pdf.size}
                        </Typography>
                      </Column>
                    </Row>
                    <Row alignItems="center" gap={1}>
                      <StyledIconButton
                        onClick={handlePreviewPDFButtonClickedWrapper(pdf)}
                      >
                        <VisibilityOutlinedIcon />
                      </StyledIconButton>
                      <StyledIconButton
                        onClick={handleDownloadPDFButtonClickedWrapper(pdf)}
                      >
                        <FileDownloadOutlined />
                      </StyledIconButton>
                    </Row>
                  </PDFContainer>
                ))}
              </Column>
            </TitledSection>
          </Grid>
        </Grid>
        <PreviewPDFDialog
          open={!!openedPDFURL}
          onClose={() => setOpenedPDFURL(null)}
          pdfURL={openedPDFURL}
        />
        <VideoDialog
          open={!!openedVideoURL}
          onClose={() => setOpenedVideoURL(null)}
          videoURL={openedVideoURL}
        />
      </PaddedContentColumn>
    </Column>
  )
}

function TitledSection({ title, children }) {
  return (
    <Column gap={4}>
      <Typography variant="h3">{title}</Typography>
      <Row sx={{ width: "100%" }}>{children}</Row>
    </Column>
  )
}

function VideoGrid({ videos, onWatchButtonClickedWrapper }) {
  return (
    <Grid container spacing={3}>
      {videos.map((video, i) => (
        <Grid xs={12} sm={6} key={i}>
          <VideoCard
            video={video}
            onWatchButtonClicked={onWatchButtonClickedWrapper(video)}
          />
        </Grid>
      ))}
    </Grid>
  )
}

function VideoCard({ video, onWatchButtonClicked }) {
  const videoURL = new URL(video.url)
  const videoPathParts = videoURL.pathname.split("/")
  const videoID = videoPathParts[videoPathParts.length - 1]

  return (
    <Card
      elevation={0}
      onClick={onWatchButtonClicked}
      sx={{ cursor: "pointer" }}
    >
      <CardMedia
        sx={{ height: { xs: "180px", sm: "200px" } }}
        image={`https://vumbnail.com/${videoID}.jpg`}
      />
      <StyledCardContent>
        <Row gap={2} alignItems="center">
          <PlayIconCircle>
            <PlayArrowOutlinedIcon />
          </PlayIconCircle>
          <Typography variant="h5" fontWeight={500}>
            {video.title}
          </Typography>
        </Row>
        <BorderedGrayChip
          label={`${Math.floor(video.length / 60)}:${(
            video.length % 60
          ).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })}`}
        />
      </StyledCardContent>
    </Card>
  )
}

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  p: theme.spacing(4),
  gap: theme.spacing(2),
  height: "96px",
}))

const PlayIconCircle = styled(Row)(({ theme }) => ({
  minWidth: "32px",
  minHeight: "32px",
  justifyContent: "center",
  alignItems: "center",
  outline: `1px solid ${theme.palette.colors.gray300}`,
  borderRadius: "50%",
  cursor: "pointer",
  transition: theme.transitions.create("background-color"),
  "&:hover": {
    backgroundColor: theme.palette.colors.brand600,
    outline: "none",
    "& .MuiSvgIcon-root": {
      fill: "white",
    },
  },
  "& .MuiSvgIcon-root": {
    width: "20px",
    height: "20px",
  },
}))

const PDFContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "&:hover": {
    ...BaseGlassMixin,
    boxShadow: "0 12px 45px rgba(0, 0, 0, 0.15)",
  },
}))

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: "8px",
  ...BaseGlassMixin,
  boxShadow: "0 12px 45px rgba(0, 0, 0, 0.15)",
}))

function VideoDialog({ open, onClose, videoURL }) {
  const isMobile = useIsMobile()
  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      sx={{
        "& .MuiPaper-root": {
          width: { xs: "100%", sm: "640px" },
          height: "360px",
          maxWidth: "min-content",
          padding: 0,
        },
      }}
    >
      <iframe
        src={videoURL}
        width={isMobile ? 350 : 640}
        height="564"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
        title="SmartSetter AI video"
      />
    </Dialog>
  )
}

function PreviewPDFDialog({ open, onClose, pdfURL }) {
  const isMobile = useIsMobile()
  const [pageCount, setPageCount] = useState(1)

  function handlePDFLoadSuccess({ numPages }) {
    setPageCount(numPages)
  }

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      maxWidth="lg"
      fullScreen={isMobile}
    >
      <Document
        file={pdfURL}
        onLoadSuccess={handlePDFLoadSuccess}
        loading={DocumentLoading}
      >
        {new Array(pageCount).fill(0).map((_, index) => (
          <Page pageNumber={index + 1} key={index} loading={() => null} />
        ))}
      </Document>
    </Dialog>
  )
}

function DocumentLoading() {
  return (
    <Backdrop open>
      <CircularProgress color="primary" size={32} />
    </Backdrop>
  )
}

class PDF {
  constructor(title, url, downloadName, sizeMB) {
    this.title = title
    this.url = url
    this.downloadName = downloadName
    this.size = `${sizeMB} MB`
  }
}
